import api from '../api/client';
import type { Booking } from './bookingApi';

export interface OldBookingPickupLocation {
  id: string;
  organizationId: string;
  name: string;
  displayOrder: number;
}

export interface OldBookingVehicle {
  id: string;
  pickupLocationId: string;
  registrationNumber: string;
  displayName: string | null;
  vehicleId: number | null;
}

export interface OldBookingMeta {
  exportedAt: string;
  dateRange: { min: string; max: string };
  bookingCount: number;
}

export interface OldBookingDayData {
  pickupLocations: OldBookingPickupLocation[];
  vehicles: OldBookingVehicle[];
  bookings: Booking[];
}

export const oldBookingApi = {
  async checkAccess(): Promise<{ hasAccess: boolean }> {
    const res = await api.get<{ success: boolean; data: { hasAccess: boolean } }>(
      '/api/booking/old-booking/access'
    );
    return res.data.data;
  },

  async getMeta(): Promise<OldBookingMeta> {
    const res = await api.get<{ success: boolean; data: OldBookingMeta }>(
      '/api/booking/old-booking/meta'
    );
    return res.data.data;
  },

  async getDayData(params: {
    date: string;
    poolId?: string;
    showAllPools?: boolean;
    organizationId?: string;
  }): Promise<OldBookingDayData> {
    const res = await api.get<{ success: boolean; data: OldBookingDayData }>(
      '/api/booking/old-booking/data',
      { params }
    );
    return res.data.data;
  },
};
